module.exports = __webpack_public_path__ + "static/img/101373.2b55e4f9.png";